import React from "react";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import Constant from "../../Constant";

function ListingOverviewTab({
  fundingProgress,
  isLand,
  pricePerUnit,
  unitsLeft,
  totalUnits,
  area,
  targetCapital,
  raised,
  developerName,
  developerPhone,
  description,
}) {
  return (
    <div className="space-y-4">
      <div className="bg-white rounded-2xl border border-[#F1F5F9] p-4 shadow-2xs">
        <div className="flex justify-between items-center text-[#1E222B] font-[700] text-[13.5px]">
          <span>Funding Progress</span>
          <span>{fundingProgress}%</span>
        </div>
        <div className="w-full h-2 bg-[#E5E7EB] rounded-full overflow-hidden mt-2.5">
          <div
            className="h-full bg-[#00BC67] rounded-full transition-all duration-700"
            style={{
              width: `${Math.min(100, Math.max(0, fundingProgress))}%`,
            }}
          />
        </div>
      </div>
      <div className="bg-white rounded-2xl border border-[#F1F5F9] p-4 shadow-2xs">
        <h3 className="text-[#1E222B] font-[700] text-[13.5px] mb-3">
          {isLand ? "Land Details" : "Property Details"}
        </h3>

        <div className="space-y-2.5">
          <div className="flex justify-between items-center text-[12.5px]">
            <span className="text-[#787F8D] font-[500]">Per Unit</span>
            <span className="text-[#1E222B] font-[700]">
              ₦{Constant.FormatNumber(pricePerUnit)}
            </span>
          </div>

          <div className="flex justify-between items-center text-[12.5px]">
            <span className="text-[#787F8D] font-[500]">Units Remaining</span>
            <span className="text-[#1E222B] font-[700]">
              {unitsLeft} of {totalUnits}
            </span>
          </div>

          <div className="flex justify-between items-center text-[12.5px]">
            <span className="text-[#787F8D] font-[500]">Area</span>
            <span className="text-[#1E222B] font-[700]">{area}</span>
          </div>

          <div className="flex justify-between items-center text-[12.5px]">
            <span className="text-[#787F8D] font-[500]">Target capital</span>
            <span className="text-[#1E222B] font-[700]">
              ₦{Constant.FormatNumber(targetCapital)}
            </span>
          </div>

          <div className="flex justify-between items-center text-[12.5px]">
            <span className="text-[#787F8D] font-[500]">Raised</span>
            <span className="text-[#1E222B] font-[700]">
              ₦{Constant.FormatNumber(raised)}
            </span>
          </div>
        </div>
      </div>
      {developerName && (
        <div className="bg-white rounded-2xl border border-[#F1F5F9] p-3.5 shadow-2xs flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-[#E8F8F0] text-[#00BC67] flex items-center justify-center flex-shrink-0">
              <ApartmentOutlinedIcon sx={{ fontSize: 22 }} />
            </div>
            <div>
              <h4 className="text-[#1E222B] font-[700] text-[13px] leading-tight">
                {developerName}
              </h4>
              <p className="text-[#808285] font-[400] text-[11px] mt-0.5">
                Verified Developers
              </p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <a
              href={`tel:${developerPhone}`}
              className="flex items-center gap-1 text-[#1E222B] font-[700] text-[12.5px] hover:text-[#00BC67] transition"
            >
              <CallOutlinedIcon sx={{ fontSize: 15, color: "#00BC67" }} />
              <span>{developerPhone}</span>
            </a>

            <CheckCircleRoundedIcon
              sx={{
                fontSize: 19,
                color: "#00BC67",
                flexShrink: 0,
              }}
            />
          </div>
        </div>
      )}

      {/* Description */}
      {description && (
        <p className="text-[#787F8D] font-[400] text-[12px] leading-relaxed px-1">
          {description}
        </p>
      )}
    </div>
  );
}

export default ListingOverviewTab;
